"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataUiDescription = exports.getDataUiActions = exports.getDataUiS3FileConfig = exports.getDataUiOverride = exports.getDataUiEnumValuesFromPicklist = exports.getDataUiEnumValuesWithKeys = exports.getDataUiEnumValues = exports.getDataUiSearchConfig = exports.getDataUiLayoutConfig = exports.getDataUiDefaultLayoutConfig = exports.getDataUiPermissions = exports.getDataUiName = exports.getEntityConstructor = exports.entityEndpoint = void 0;
const change_case_1 = require("change-case");
const typeorm_1 = require("typeorm");
const constants_1 = require("./constants");
function entityEndpoint(entity) {
    return `entity/${(0, change_case_1.paramCase)(entity.name)}`;
}
exports.entityEndpoint = entityEndpoint;
function getEntityConstructor(entity, connection) {
    if (typeof entity === 'string') {
        const metadata = (connection || (0, typeorm_1.getConnection)()).getMetadata(entity);
        if (metadata) {
            return metadata.target;
        }
        throw new Error('Failed to find entity for: ' + entity);
    }
    return entity;
}
exports.getEntityConstructor = getEntityConstructor;
function getDataUiName(target, propertyKey) {
    return Reflect.getMetadata(constants_1.DATA_UI_NAME_METADATA, target, propertyKey);
}
exports.getDataUiName = getDataUiName;
function getDataUiPermissions(target, propertyKey) {
    return Reflect.getMetadata(constants_1.DATA_UI_PERMISSIONS_METADATA, target, propertyKey);
}
exports.getDataUiPermissions = getDataUiPermissions;
function getDataUiDefaultLayoutConfig(target) {
    return Reflect.getMetadata(constants_1.DATA_UI_LAYOUT_CONFIG_METADATA, target);
}
exports.getDataUiDefaultLayoutConfig = getDataUiDefaultLayoutConfig;
function getDataUiLayoutConfig(target, propertyKey) {
    return Reflect.getMetadata(constants_1.DATA_UI_LAYOUT_CONFIG_METADATA, target, propertyKey);
}
exports.getDataUiLayoutConfig = getDataUiLayoutConfig;
function getDataUiSearchConfig(target, propertyKey) {
    return Reflect.getMetadata(constants_1.DATA_UI_SEARCH_CONFIG_METADATA, target, propertyKey);
}
exports.getDataUiSearchConfig = getDataUiSearchConfig;
function getDataUiEnumValues(target, propertyKey) {
    return Reflect.getMetadata(constants_1.DATA_UI_ENUM_VALUES_METADATA, target, propertyKey);
}
exports.getDataUiEnumValues = getDataUiEnumValues;
function getDataUiEnumValuesWithKeys(target, propertyKey) {
    return Reflect.getMetadata(constants_1.DATA_UI_ENUM_VALUES_WITH_KEYS_METADATA, target, propertyKey);
}
exports.getDataUiEnumValuesWithKeys = getDataUiEnumValuesWithKeys;
function getDataUiEnumValuesFromPicklist(target, propertyKey) {
    return Reflect.getMetadata(constants_1.DATA_UI_ENUM_VALUES_FROM_PICKLIST_METADATA, target, propertyKey);
}
exports.getDataUiEnumValuesFromPicklist = getDataUiEnumValuesFromPicklist;
function getDataUiOverride(target, propertyKey) {
    return Reflect.getMetadata(constants_1.DATA_UI_TEXT_LENGTH_METADATA, target, propertyKey);
}
exports.getDataUiOverride = getDataUiOverride;
function getDataUiS3FileConfig(target, propertyKey) {
    return Reflect.getMetadata(constants_1.DATA_UI_S3FILE_CONFIG_METADATA, target, propertyKey);
}
exports.getDataUiS3FileConfig = getDataUiS3FileConfig;
function getDataUiActions(target) {
    return Reflect.getMetadata(constants_1.DATA_UI_ADDITIONAL_ACTION, target);
}
exports.getDataUiActions = getDataUiActions;
function getDataUiDescription(target, propertyKey) {
    return Reflect.getMetadata(constants_1.DATA_UI_DESCRIPTION_METADATA, target, propertyKey);
}
exports.getDataUiDescription = getDataUiDescription;
//# sourceMappingURL=helpers.js.map